export const SURFACE_CHANNEL = 'slate.surface';

export type ThemeSnapshot = Record<string, string>;

export interface SurfaceReadyFrame {
  channel: typeof SURFACE_CHANNEL;
  t: 'ready';
}
export interface SurfaceMessageUpFrame {
  channel: typeof SURFACE_CHANNEL;
  t: 'message';
  instanceId: string;
  message: unknown;
}
export type SurfaceToHostFrame = SurfaceReadyFrame | SurfaceMessageUpFrame;

export interface SurfaceInitFrame {
  channel: typeof SURFACE_CHANNEL;
  t: 'init';
  instanceId: string;
  theme: ThemeSnapshot;
}
export interface SurfaceMessageDownFrame {
  channel: typeof SURFACE_CHANNEL;
  t: 'message';
  instanceId: string;
  message: unknown;
}
export type HostToSurfaceFrame = SurfaceInitFrame | SurfaceMessageDownFrame;

export type SurfaceFrame = SurfaceToHostFrame | HostToSurfaceFrame;

/** Reject anything that is not one of our tagged frames. The host and the client
 *  both run this on every inbound postMessage before acting. */
export function isSurfaceFrame(v: unknown): v is SurfaceFrame {
  if (typeof v !== 'object' || v === null) return false;
  const f = v as { channel?: unknown; t?: unknown; instanceId?: unknown };
  if (f.channel !== SURFACE_CHANNEL) return false;
  switch (f.t) {
    case 'ready':
      return true;
    case 'message':
      // Both directions of a 'message' frame carry a correlating instanceId and
      // a payload property.
      return typeof f.instanceId === 'string' && 'message' in f;
    case 'init':
      return typeof f.instanceId === 'string' && 'theme' in f;
    default:
      return false;
  }
}
